module.exports = __webpack_public_path__ + "static/img/signin_pic.b2025fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sys/login/signin_pic.png
// module id = gKVm
// module chunks = 1